import type { IconNode } from '../types';

/**
 * @name feather-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMyAzSDVhMiAyIDAgMCAwLTIgMnYxNGEyIDIgMCAwIDAgMiAyaDE0YTIgMiAwIDAgMCAyLTJ2LTguOCIgLz4KICA8cGF0aCBkPSJNNyAxMmw4LjUtOC41YzItMiA0LjUtMiA2LjUgMEwxNi41IDlIMTAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/feather-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const featherSquare: IconNode = [
  ['path', { d: 'M10.3 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8.8', key: '17ye1e' }],
  ['path', { d: 'M7 12l8.5-8.5c2-2 4.5-2 6.5 0L16.5 9H10', key: 'z4zbcx' }],
];

export default featherSquare;
